const FooterCopyright = () => {
    const year = new Date().getFullYear();

    return (
        <p className="relative font-[Helvetica] text-white text-sm lg:text-base leading-normal uppercase">
            © INNER BALANCE {year}. ALL RIGHTS RESERVED.
        </p>
    )
};

export default FooterCopyright;
